import React from 'react';
import styled from 'styled-components';

export default function Radio({ checked = false, onClick, text = '' }) {
  return (
    <SRadio className={`${checked ? 'checked' : ''}`} {...{ onClick }}>
      <div className="radio"></div>
      <span className="label">{text}</span>
    </SRadio>
  );
}

export const SRadio = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  width: fit-content;

  .radio {
    width: 16px;
    height: 16px;
    min-width: 16px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid;
    position: relative;
    margin-right: 8px;
    &:after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 8px;
      height: 8px;
      min-width: 4px;
      border-radius: 4px;
      transform: scale(0);
      transition: 0.1s;
      background-color: #00cb82;
    }
  }
  &:not(.checked) {
    .radio {
      border-color: #9ab1cc;
    }
    .label {
      color: #718098;
    }
  }
  &.checked {
    .radio {
      border-color: #00cb82;
      &:after {
        transform: scale(1);
      }
    }
    .label {
      color: #333b6a;
      font-weight: 500;
    }
  }
  .label {
    font-size: 16px;
    line-height: 24px;
    user-select: none;
  }
`;
